module.exports = __webpack_public_path__ + "static/img/3.73857df6.jpg";